import useTypedTranslation from "@/core/hooks/use-typed-translation";
import { cn } from "@/core/utils/func/cn";
import { Loader2 } from "lucide-react";
import React, { HTMLProps } from "react";
import { ButtonSizesType } from "./button-size.type";

interface ButtonSpinnerProps {
  size?: ButtonSizesType;
  className?: HTMLProps<HTMLElement>["className"];
}

const SvgSize: Record<ButtonSizesType, string> = {
  lg: "w-10 h-10",
  default: "w-4 h-4",
  sm: "w-3 h-3",
  icon: "w-4 h-4",
};

export const ButtonSpinner: React.FC<ButtonSpinnerProps> = ({
  size = "default",
  className,
}) => {
  const { t } = useTypedTranslation();
  return (
    <div role="status" data-testid="button-spinner">
      <Loader2
        className={cn(
          "mr-2 text-white animate-spin",
          size && SvgSize[size],
          className
        )}
      />
      <span className="sr-only">{t("loadingText")}</span>
    </div>
  );
};
